export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/photographic.33e406d.svg";